export enum ScannerActionType {
  AddCounterIndex = 'add-counter-index',
  CreateIntervention = 'create-intervention',
  FindInterventions = 'find-interventions',
  FindTasks = 'find-tasks',
}
